import { useEffect, useState } from "react";
// import { fetchForecast } from "./services/forecastApi";
import {StockServices} from '../../services/stockServices';
import ForecastFilters from "./ForecastFilters";
import ForecastSummary from "./ForecastSummary";
import ForecastChart from "./ForecastChart";
import ForecastTable from "./ForecastTable";

const ForecastDashboard = () => {
  const [filters, setFilters] = useState({ days: 30,product_id:'PROD-4321',warehouse_id:'WH-001' });
  const [forecast, setForecast] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(false);
    StockServices.fetchForecast(filters)
      .then(setForecast)
      .finally(() => setLoading(false));
      console.log(forecast,'forecastdata');
  }, [filters]);

  if (loading) return <p>Loading forecast...</p>;

  return (
    <>
      <ForecastFilters onChange={setFilters} />
      {forecast && (
        <>
          <ForecastSummary data={forecast.data} />
          <ForecastChart data={forecast.data.trend} />
          <ForecastTable data={forecast.data} />
        </>
      )}
    </>
  );
};

export default ForecastDashboard;
